import { useApp } from "../context/AppContext";
import DriveView from "../views/DriveView";

export default function DrivePage() {
  const ctx = useApp();
  return (
    <DriveView
      driveAccounts={ctx.driveAccounts} activeDriveAccountId={ctx.activeDriveAccountId}
      setActiveDriveAccountId={ctx.setActiveDriveAccountId} driveFiles={ctx.driveFiles}
      driveMessage={ctx.driveMessage} setDriveMessage={ctx.setDriveMessage} importingDrive={ctx.importingDrive}
      importDriveFile={ctx.importDriveFile} fetchDriveFiles={ctx.fetchDriveFiles}
      connectGoogleDrive={ctx.connectGoogleDrive} disconnectDriveAccount={ctx.disconnectDriveAccount}
      checkDriveStatus={ctx.checkDriveStatus} files={ctx.files}
    />
  );
}